// @ts-ignore
// @ts-nocheck

import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import DriveFileRenameOutline from "@mui/icons-material/DriveFileRenameOutline";
import GetAppIcon from "@mui/icons-material/GetApp";
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Drawer,
  Grid,
  MenuItem,
  Paper,
  Stack,
  TextField as TF
} from "@mui/material";
import moment from "moment";
import React from "react";
import {
  BooleanField,
  Confirm,
  Datagrid,
  DateField,
  FunctionField,
  Pagination,
  Button as RAButton,
  RaRecord,
  ReferenceField,
  ReferenceManyField,
  Show,
  ShowController,
  SimpleShowLayout,
  Tab,
  TabbedShowLayout,
  TextField,
  useCreate,
  useRecordContext,
} from "react-admin";
import ReactJson from "react-json-view";
import FormKycDialog from "./FormKycDialog";
import FormKycDialogPassport from "./FormKycDialogPassport";
// @ts-ignore
import EditIcon from "@mui/icons-material/Edit";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import axios from "axios";
import createHash from "crypto-browserify";
import { endOfToday, format } from "date-fns";
import { useNavigate } from "react-router-dom";
import { secretbox } from "tweetnacl";
import { useRetrievePermission } from "../../hooks/useRetrievePermission";
import mbaas from "../../provider/Mbaas";
import { requestKycUrl } from "../../provider/kycScripts";
import { ReactPanZoom } from "../RaPhotoPan";
import AdjustPointModal from "./AdjustPointModal";
import DetailPage from "./DetailPage";
import EditCoinModal from "./EditCoinModal";
import EditVnExpiryModal from "./EditVnExpiryModal";
import SwitchVNModal from "./SwitchVNModal";

const ExpandShow = (props: any) => {
  // activities
  const [cdr, setCdr] = React.useState("sms");
  const [msisdn, setMsisdn] = React.useState("");
  // common
  const fromData = moment().subtract(30, "days").format("YYYY-MM-DD");
  const toData = moment().format("YYYY-MM-DD");
  const [datex, setDate] = React.useState(fromData);
  const [datey, setDatey] = React.useState(toData);
  const [app, setApp] = React.useState("")
  const [openForm, setOpenForm] = React.useState(false);
  const [openFormPass, setOpenFormPass] = React.useState(false);
  const [imgblob, setImgblob] = React.useState("");
  const [imgzoom, setImgzoom] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [idValue, setIdValue] = React.useState("");
  const [data, setData] = React.useState({});
  const [currentRecord, setCurrentRecord] = React.useState({} as RaRecord);
  const [loggedInUser, setLoggedInUser] = React.useState({});
  const [openSwitchVNModal, setOpenSwitchVNModal] = React.useState(false);
  const [openEditCoinModal, setOpenEditCoinModal] = React.useState(false);
  const [openAdjustPointModal, setOpenAdjustPointModal] = React.useState(false);
  const [openEditVnExpiryModal, setOpenEditVnExpiryModal] =
    React.useState(false);

  const [isSuperAdmin, isAdmin, isStaff] = useRetrievePermission();

   const getUserData = async () => {
      const res = await mbaas.client.user.get();
      if (res.data) {
        setLoggedInUser(res.data);
      }
      if (res.error) {
        // @ts-ignore
        notify(res.error);
      }
    };
  
    React.useEffect(() => {
      getUserData();
    }, []);

  const [checkedItems, setCheckedItems] = React.useState({
    debit: true,
    credit: true,
  });
  const handleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  }

  const handleRowClick = (id, valueDrawer) => {
    setIdValue(id)
    setDrawerOpen(valueDrawer);
  };

  const CheckboxList = ({ checkedItems, setCheckedItems }) => {

    const options = [
      { value: 'debit', label: 'DEBIT' },
      { value: 'credit', label: 'CREDIT' }
    ];

    const handleCheckboxChange = (event) => {
      const { name, checked } = event.target;

      if (checked === true) {
        setCheckedItems({ ...checkedItems, [name]: true });
      } else {
        setCheckedItems({ ...checkedItems, [name]: false });
      }

    };

    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {options.map(option => (
          <div key={option.value} style={{ marginInline: '10px' }}>
            <input
              type="checkbox"
              id={option.value}
              name={option.value}
              value={option.value}
              checked={checkedItems[option.value]}
              onChange={handleCheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label htmlFor={option.value}>{option.label}</label>
          </div>
        ))}
      </div>
    );
  };

  const JsonField = (props: any) => {
    const record = useRecordContext(props);

    return (
      <ReactJson
        src={record[props.target] !== null ? record[props.target] : {}}
        displayDataTypes={false}
        name={null}
        collapsed={0}
        enableClipboard={false}
      />
    );
  };

  const ReviewKYC = (props: any) => {
    // const record = useRecordContext(props);
    const record = props.data;
    return (
      <Button
        variant="contained"
        size="small"
        startIcon={<DocumentScannerIcon />}
        disabled={record.verified_by !== null}
        onClick={() => {
          setData(record);
          setOpenForm(true);
        }}
      >
        Review Number
      </Button>
    );
  };

  const getDocumentColumn = (record: any) => {
    let idTypeValue = "passport-sip";

    const idData = record?.passports_registration_id_list?.data?.[0];

    if (idData?.id_type) {
      switch (idData.id_type) {
        case "HKID":
          idTypeValue = "hkid";
          break;

        case "ARC":
          idTypeValue = "arc";
          break;

        case "PASSPORT":
          idTypeValue = "passport";
          break;
      }
    } else if (idData?.partner === "ARMADA") {
      idTypeValue = "armada";
    } else if (idData?.document_id?.startsWith("passport-documents")) {
      idTypeValue = "passport";
    }

    let idColumnName = "document_id";

    switch (idTypeValue) {
      case "hkid":
        idColumnName = "hk_id";
        break;

      case "arc":
      case "armada":
        idColumnName = "arc_front";
        break;
    }

    return idColumnName;
  };

  const ReviewKYCPassport = (props: any) => {
    // const record = useRecordContext(props);
    const record = props.data;
    return (
      <Button
        variant="contained"
        size="small"
        startIcon={<DocumentScannerIcon />}
        // disabled={record.verified_by !== null}
        disabled={false}
        onClick={() => {
          setData(record);
          setOpenFormPass(true);
        }}
      >
        Review Account
      </Button>
    );
  };

  const decryptFile = async (user: any, fileid: string, data:any) => {
    setLoading(true);
    setImgzoom(true);
    try {
      const secretUser = user.secret;
      const idUser = user.id;

      const secret = secretUser + idUser;

      const key = createHash.createHash("sha256").update(secret).digest();
      let url = "";
      let idTypeValue = "passport-sip";

      if(data?.passports_registration_id_list?.data[0]?.id_type) {
        // M21 BUCKET (REGISTRATIONS)
        switch(data.passports_registration_id_list.data[0].id_type) {
          case "HKID":
            idTypeValue = "hkid";
            break;

          case "ARC":
            idTypeValue = "arc";
            break;

          case "PASSPORT":
            idTypeValue = "passport";
            break;
        }
      } else if (
        data?.passports_registration_id_list?.data[0]?.partner === "ARMADA"
      ) {
        // M21 BUCKET (PARTNERS)
        idTypeValue = "armada";
      } else if (
        fileid?.startsWith("passport-documents") || fileid?.startsWith("passport-selfies")
      ) {
        // M21 BUCKET (REGISTRATIONS) but encrypted
        idTypeValue = "passport";
      }
      // Some PASSPORT submissions have id_type set but the file was still
      // stored via the SIP upload mechanism (filename like "202606/..."),
      // not in the registrations bucket. The filename format is a more
      // reliable signal of where the file physically lives than id_type
      // alone, otherwise the registrations-bucket lookup 404s.
      if (idTypeValue === "passport" && /^\d{6}\//.test(fileid || "")) {
        idTypeValue = "passport-sip";
      }
      // DEFAULT TO PASSPORT-SIP
      let encrypted = false
      if(idTypeValue === 'passport-sip') {
      const req = await requestKycUrl(fileid, "DOWNLOAD");
        url = req.data.url;
      } else {
        encrypted = !data?.passports_registration_id_list?.data[0]?.id_type && idTypeValue === 'passport'
        const imgUrl = await mbaas.client.storage.downloadUrl({
          params: {
            bucket: idTypeValue === 'armada' ? "partners" : "registrations",
            expire: "20",
          },
          fileId: fileid,
        });
        url = imgUrl.data.url;
      }

      if (encrypted) {
        const { data: mergedtext } = await axios.request({
          method: "get",
          url,
          responseType: "arraybuffer",
        });
        const nonce = mergedtext.slice(0, secretbox.nonceLength);
        const ciphertext = mergedtext.slice(
          secretbox.nonceLength,
          mergedtext.length
        );
        const chpr = new Uint8Array(ciphertext);
        const iv = new Uint8Array(nonce);

        const plaintext = secretbox.open(chpr, iv, key);
        // const plaintext = secretbox.open(ciphertext, nonce, key);

        if (plaintext) {
          const base64Plain = Buffer.from(plaintext).toString("base64");
          setImgblob("data:image/jpeg;base64," + base64Plain);
        } else {
          // Not all files on this path are secretbox-encrypted; some are
          // already plain images. Fall back to the raw bytes when decode
          // fails instead of erroring out and leaving the image blank.
          const base64Raw = Buffer.from(mergedtext).toString("base64");
          setImgblob("data:image/jpeg;base64," + base64Raw);
        }
      } else if (data?.passports_registration_id_list?.data[0]?.id_type || idTypeValue === 'passport-sip') {
        const { data: imageBuffer } = await axios.request({
            method: "GET",
            url,
            responseType: "arraybuffer",
          });
          const plaintext = secretbox.open(
            new Uint8Array(imageBuffer.slice(secretbox.nonceLength)),
            new Uint8Array(imageBuffer.slice(0, secretbox.nonceLength)),
            key
          );

          // Not all passport-sip files are secretbox-encrypted; some are
          // already plain images. Fall back to the raw bytes when decode
          // fails instead of erroring out and leaving the image blank.
          const base64Data = Buffer.from(plaintext || imageBuffer).toString(
            "base64"
          );
          setImgblob("data:image/jpeg;base64," + base64Data);
      } else {
        setImgblob(url);
      }
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };

  const handleOpenEditCoinModal = () => {
    setOpenEditCoinModal(true);
  };
  const handleCloseEditCoinModal = () => setOpenEditCoinModal(false);


  const handleOpenAdjustPointModal = () => {
    setOpenAdjustPointModal(true);
  };
  const handleCloseAdjustPointModal = () => setOpenAdjustPointModal(false);

  const handleOpenEditVnExpiryModal = () => {
    setOpenEditVnExpiryModal(true);
  };
  const handleCloseEditVnExpiryModal = () => setOpenEditVnExpiryModal(false);

  const handleOpenSwitchVNModal = () => {
    setOpenSwitchVNModal(true);
  };

  const handleCloseSwitchVNModal = () => setOpenSwitchVNModal(false);

  const [open, setOpen] = React.useState(false);
  const [authorData, setAuthorData] = React.useState({});

  const navigate = useNavigate();

  const ExportReferredButton = (props) => {
    const getAuthorData = async () => {
      const res = await mbaas.client.user.get();
      if (res.data) {
        return res.data;
      }
      if (res.error) {
        // @ts-ignore
        notify(res.error);
      }
    };
    getAuthorData().then((data) => {
      setAuthorData(data.id);
    });
    //
    const type_name = "referred-by-promotor";
    const gen_file_name = `${type_name}_${format(
      new Date(endOfToday()),
      "yyyy-MM-dd"
    )}`;
    //
    console.log("filterValues", props);
    //
    const [exportData, { data, error }] = useCreate("reports", {
      data: {
        author_id: authorData,
        type: type_name,
        status: "queued",
        data: {
          filter: {
            dateGte: moment(new Date(datex)).startOf("day").toISOString(),
            dateLte: moment(new Date(datey)).endOf("day").toISOString(),
            promotorId: props?.subs_id,
          },
          metadata: {
            generated_filename: gen_file_name, // jika ada
          },
        },
      },
    });

    if (data && !error) {
      //
      console.log(767, "haiii");
    }

    const handleOnClick = () => {
      exportData();
      setOpen(true);
    };

    const navigateToReportPage = () => {
      navigate(encodeURI(`/reports?filter={"type":"referred-by-promotor"}`));
    };
    const ConfirmDialogContent = () => {
      return (
        <Paper elevation={0}>
          <Typography variant="body1" gutterBottom>
            Your file is exported as "{gen_file_name}.csv", to view the progress
            please visit report page below
          </Typography>
        </Paper>
      );
    };

    return (
      <RAButton
        variant="contained"
        label="Export"
        size="medium"
        onClick={() => handleOnClick()}
      >
        <GetAppIcon />
        <Confirm
          isOpen={open}
          title="Dear User,"
          content={<ConfirmDialogContent />}
          onClose={() => setOpen(false)}
          confirm="Go To Report"
          onConfirm={navigateToReportPage}
        />
      </RAButton>
    );
  };

  return (
    <>
      <ShowController {...props}>
        {(controllerProps) => (
          <Show {...props} title="Subscriber Detail" {...controllerProps}>
            <FunctionField
              render={(record: RaRecord) => setCurrentRecord(record)}
            />
            <SimpleShowLayout>
              <FormKycDialog
                open={openForm}
                setOpen={setOpenForm}
                data={data}
              />
              <FormKycDialogPassport
                open={openFormPass}
                setOpen={setOpenFormPass}
                data={data}
              />
              <Dialog
                open={imgzoom}
                aria-labelledby="form-dialog-title"
                maxWidth="md"
                fullWidth={true}
              >
                <DialogTitle id="form-dialog-title">File Detail</DialogTitle>
                <DialogContent>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    {loading ? (
                      "LOADING . . ."
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          height: "70vh",
                          position: "relative",
                          overflow: "hidden",
                        }}
                      >
                        <ReactPanZoom image={imgblob} alt="imgpreview" />
                      </div>
                    )}
                  </div>
                </DialogContent>
                <DialogActions>
                  <Grid item gap={2} marginBottom={2}>
                    <Button
                      style={{ marginRight: "20px" }}
                      variant="outlined"
                      size="small"
                      type="submit"
                      onClick={() => setImgzoom(false)}
                    >
                      Close
                    </Button>
                  </Grid>
                </DialogActions>
              </Dialog>

              <TabbedShowLayout>
                <Tab label="profile" path="">
                  <TextField label="Name" source="name" />
                  <TextField label="Email" source="email" />
                  <TextField label="Phone" source="phone" />
                  <FunctionField
                    source="deactivated_at"
                    label="Blocked"
                    render={(
                      record: { deactivated_at: any },
                      source: string | undefined
                    ) => (
                      <BooleanField
                        record={{
                          ...record,
                          deactivated_at: !!record.deactivated_at,
                        }}
                        source={source}
                      />
                    )}
                  />
                  <div>
                    <Typography variant="caption" display="block" gutterBottom>
                      Current Coin Balance
                    </Typography>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        marginTop: "-12px",
                      }}
                    >
                      <TextField
                        label="Current Coin Balance"
                        source="current_balance"
                      />
                      {(isSuperAdmin || isAdmin) && (
                        <Tooltip title="Edit Subscriber Coin">
                          <Button
                            style={{ marginLeft: "61px" }}
                            onClick={() => handleOpenEditCoinModal()}
                          >
                            <EditIcon />
                          </Button>
                        </Tooltip>
                      )}
                      <EditCoinModal
                        open={openEditCoinModal}
                        currentRecord={currentRecord}
                        handleClose={handleCloseEditCoinModal}
                      />
                    </div>
                  </div>
                  <div>
                    <Typography variant="caption" display="block" gutterBottom>
                      Virtual MSISDN
                    </Typography>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        marginTop: "5px",
                      }}
                    >
                      <TextField label="Virtual MSISDN" source="vn_msisdn" />
                      {(isSuperAdmin || isAdmin || loggedInUser?.email?.includes("hash")) &&
                        currentRecord?.virtual_msisdn_user_id_list?.data
                          ?.length === 0 && (
                          <Tooltip title="Switch VN">
                            <Button
                              style={{ marginLeft: "61px" }}
                              onClick={() => handleOpenSwitchVNModal()}
                            >
                              <EditIcon />
                            </Button>
                          </Tooltip>
                        )}
                      <SwitchVNModal
                        open={openSwitchVNModal}
                        currentRecord={currentRecord}
                        handleClose={handleCloseSwitchVNModal}
                      />
                    </div>
                  </div>
                  <div>
                    <Typography variant="caption" display="block" gutterBottom>
                      Virtual Number Expiry Date
                    </Typography>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        marginTop: "-12px",
                      }}
                    >
                      <TextField
                        label="Virtual Number Expiry Date"
                        source="vn_expiry"
                      />
                      {(isSuperAdmin || isAdmin) && (
                        <Tooltip title="Edit Virtual Number Expiry Date">
                          <Button
                            style={{ marginLeft: "61px" }}
                            onClick={() => handleOpenEditVnExpiryModal()}
                          >
                            <EditIcon />
                          </Button>
                        </Tooltip>
                      )}

                    <EditVnExpiryModal
                      open={openEditVnExpiryModal}
                      currentRecord={currentRecord}
                      handleClose={handleCloseEditVnExpiryModal}
                    />
                  </div>
                </div>
                <TextField label="Referral code" source="referral_code" />
                <JsonField target="referral_detail" label="Referral detail" />
                <TextField
                  label="Referrer"
                  source="referral_referrer_id_data.email"
                />
                <JsonField
                  target="referral_referrer_id_data"
                  label="Referrer detail"
                />

                {/* <ReviewKYC /> */}
              </Tab>

              <Tab label="Limit" path="limit">
                <TextField source="max_coins" />
                <TextField source="max_daily_purchase" />
                <TextField source="max_monthly_purchase" />
                <TextField source="preferred_language" />
              </Tab>
              <Tab label="point" path="point">
                <Grid container gap={3}>
                  <TF
                    id="date"
                    label="From"
                    type="date"
                    value={datex}
                    onChange={(e) => {
                      setDate(e.target.value);
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TF
                    id="date"
                    label="To"
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={datey}
                    onChange={(e) => {
                      setDatey(e.target.value);
                    }}
                  />
                  <CheckboxList checkedItems={checkedItems} setCheckedItems={setCheckedItems} />
                  <Box flex={"auto"} display={"flex"} justifyContent={"right"} py={2}>
                    {(isSuperAdmin || isAdmin) && (
                      <Button
                        size="small"
                        variant="contained"
                        onClick={handleOpenAdjustPointModal}
                        startIcon={<DriveFileRenameOutline />}
                      >
                        Adjust
                      </Button>
                    )}
                    <AdjustPointModal
                      open={openAdjustPointModal}
                      currentRecord={currentRecord}
                      handleClose={handleCloseAdjustPointModal}
                    />
                  </Box>
                </Grid>
                <ReferenceManyField
                  label=""
                  reference="subscribers"
                  target="id"
                  pagination={<Pagination />}
                  perPage={25}
                  filter={{
                    table: "wallet",
                    type: "POINT",
                    start: datex,
                    end: datey,
                  }}

                  sort={{ field: "created_at", order: "desc" }}
                >
                  <Datagrid
                    rowClick={(id) => {
                      handleRowClick(id, true)
                    }}
                    bulkActionButtons={false}>
                    <TextField source="remark" />
                    <TextField source="unit" />
                    <TextField source="balance" />
                    {checkedItems.debit && <TextField source="debit" />}
                    {checkedItems.credit && <TextField source="credit" />}
                    <DateField source="created_at" showTime />
                    <DateField source="updated_at" showTime />
                    <ReferenceField
                      source="wallet_id_data.user_id_data.id"
                      reference="users"
                      label="User"
                    >
                      <TextField source="name" />
                    </ReferenceField>
                  </Datagrid>
                </ReferenceManyField>
                <Drawer
                  variant="persistent"
                  open={drawerOpen}
                  anchor="right"
                  onClose={handleDrawer}
                  sx={{ zIndex: 100 }}
                >
                  <DetailPage walletId={idValue} onClose={handleDrawer} />
                </Drawer>
              </Tab>

              <Tab label="coin" path="coin">
                <Grid container gap={3}>
                  <TF
                    id="date"
                    label="From"
                    type="date"
                    value={datex}
                    onChange={(e) => {
                      setDate(e.target.value);
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TF
                    id="date"
                    label="To"
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={datey}
                    onChange={(e) => {
                      setDatey(e.target.value);
                    }}
                  />
                </Grid>
                <ReferenceManyField
                  label=""
                  reference="subscribers"
                  target="id"
                  pagination={<Pagination />}
                  perPage={25}
                  filter={{
                    table: "wallet",
                    type: "HKD",
                    start: datex,
                    end: datey,
                  }}
                  sort={{ field: "created_at", order: "desc" }}
                >
                  <Datagrid bulkActionButtons={false}>
                    <TextField source="remark" sortable={false} />
                    <TextField source="unit" />
                    <FunctionField
                      label="Balance Before"
                      render={(record: RaRecord) => {
                        if (record.debit !== 0) {
                          return (
                            <span>
                              {Number((record.balance + record.debit).toFixed(2))}
                            </span>
                          );
                        }
                        if (record.credit !== 0) {
                          return (
                            <span>
                              {Number((record.balance - record.credit).toFixed(2))}
                            </span>
                          );
                        }
                        return <span>{record.balance}</span>;
                      }}
                    />
                    <TextField source="balance" label={"Balance After"} />
                    <TextField source="debit" />
                    <TextField source="credit" />
                    <DateField source="created_at" showTime />
                    <DateField source="updated_at" showTime />
                    <FunctionField
                      label="Updated By"
                      render={(record: RaRecord) => {
                        if (record.metadata) {
                          return <span>{record.metadata.by.name}</span>;
                        }
                        return <span>-</span>;
                      }}
                    />
                    <FunctionField
                      label="Reason"
                      render={(record: RaRecord) => {
                        if (record.metadata) {
                          return (
                            <span>{record.metadata.changes.reason}</span>
                          );
                        }
                        return <span>-</span>;
                      }}
                    />
                    <ReferenceField
                      source="wallet_id_data.user_id_data.id"
                      reference="users"
                      label="User"
                    >
                      <TextField source="name" />
                    </ReferenceField>
                  </Datagrid>
                </ReferenceManyField>
              </Tab>
              <Tab label="package" path="package">
                <Grid container gap={3}>
                  <TF
                    id="date"
                    label="From"
                    type="date"
                    value={datex}
                    onChange={(e) => {
                      setDate(e.target.value);
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TF
                    id="date"
                    label="To"
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={datey}
                    onChange={(e) => {
                      setDatey(e.target.value);
                    }}
                  />
                </Grid>
                <ReferenceManyField
                  label=""
                  reference="subscribers"
                  target="id"
                  pagination={<Pagination />}
                  perPage={25}
                  filter={{
                    table: "package",
                    type: "package",
                    start: datex,
                    end: datey,
                  }}
                  sort={{ field: "created_at", order: "desc" }}
                >
                  <Datagrid bulkActionButtons={false}>
                    <TextField source="remark" />

                    <FunctionField
                      label="Package Detail"
                      render={(record: any) => {
                        if (record.package_detail) {
                          return (
                            <ReactJson
                              src={record.package_detail || []}
                              collapsed={0}
                              enableClipboard={false}
                              displayDataTypes={false}
                              displayObjectSize={false}
                              name={false}
                            />
                          );
                        } else {
                          return "-";
                        }
                      }}
                    />

                    <DateField source="expiry_date" showTime />

                    <DateField source="created_at" showTime />
                    <DateField source="updated_at" showTime />
                  </Datagrid>
                </ReferenceManyField>
              </Tab>
              <Tab label="Sms Quota" path="sms">
                <Grid container gap={3}>
                  <TF
                    id="date"
                    label="From"
                    type="date"
                    value={datex}
                    onChange={(e) => {
                      setDate(e.target.value);
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TF
                    id="date"
                    label="To"
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={datey}
                    onChange={(e) => {
                      setDatey(e.target.value);
                    }}
                  />
                </Grid>
                <ReferenceManyField
                  label=""
                  reference="subscribers"
                  target="id"
                  perPage={25}
                  pagination={<Pagination />}
                  filter={{
                    table: "quota",
                    type: "SMS",
                    start: datex,
                    end: datey,
                  }}
                  sort={{ field: "created_at", order: "desc" }}
                >
                  <Datagrid bulkActionButtons={false}>
                    <TextField source="remark" />
                    <TextField source="unit" />
                    <TextField source="balance" />
                    <TextField source="debit" />
                    <TextField source="credit" />
                    <DateField source="created_at" showTime />
                    <DateField source="updated_at" showTime />
                    <ReferenceField source="user_id" reference="users">
                      <TextField source="name" />
                    </ReferenceField>
                  </Datagrid>
                </ReferenceManyField>
              </Tab>

              <Tab label="Voice Quota" path="voice">
                <Grid container gap={3}>
                  <TF
                    id="date"
                    label="From"
                    type="date"
                    value={datex}
                    onChange={(e) => {
                      setDate(e.target.value);
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TF
                    id="date"
                    label="To"
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={datey}
                    onChange={(e) => {
                      setDatey(e.target.value);
                    }}
                  />
                </Grid>
                <ReferenceManyField
                  label=""
                  reference="subscribers"
                  target="id"
                  perPage={25}
                  pagination={<Pagination />}
                  filter={{
                    table: "quota",
                    type: "MINUTES",
                    start: datex,
                    end: datey,
                  }}
                  sort={{ field: "created_at", order: "desc" }}
                >
                  <Datagrid bulkActionButtons={false}>
                    <TextField source="remark" />
                    <TextField source="unit" />
                    <TextField source="balance" />
                    <TextField source="debit" />
                    <TextField source="credit" />
                    <DateField source="created_at" showTime />
                    <DateField source="updated_at" showTime />
                    {/* <ReferenceField source="user_id" reference="users">
                    <TextField source="name" />
                  </ReferenceField> */}
                  </Datagrid>
                </ReferenceManyField>
              </Tab>
              <Tab label="activites" path="activities">
                <Grid container gap={3}>
                  <TF
                    id="date"
                    label="From"
                    type="date"
                    value={datex}
                    onChange={(e) => {
                      setDate(e.target.value);
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    data-testid="filter-date-start"
                  />
                  <TF
                    id="date"
                    label="To"
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={datey}
                    onChange={(e) => {
                      setDatey(e.target.value);
                    }}
                    data-testid="filter-date-end"
                  />
                  <TF
                    select
                    value={cdr}
                    label="Data"
                    onChange={(e) => {
                      setCdr(e.target.value);
                    }}
                    data-testid="filter-data-cdr"
                  >
                    <MenuItem value="sms">SMS</MenuItem>
                    <MenuItem value="voice">VOICE</MenuItem>
                  </TF>
                  <TF
                    label="Number"
                    value={msisdn}
                    onChange={(e) => {
                      setMsisdn(e.target.value);
                    }}
                    data-testid="filter-number"
                  />
                </Grid>
                <ReferenceManyField
                  label=""
                  reference="subscribers"
                  target="id"
                  pagination={<Pagination />}
                  perPage={25}
                  filter={{
                    table: "activities",
                    type: "activities",
                    start: datex,
                    end: datey,
                    cdr,
                    msisdn,
                  }}
                  sort={{ field: "created_at", order: "desc" }}
                >
                  <Datagrid bulkActionButtons={false}>
                    <DateField
                      source="created_at"
                      label="Date"
                      showTime
                      locales="en-HK"
                      options={{
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                        second: "numeric",
                      }}
                    />
                    <TextField source="direction" />
                    {cdr === "voice" ? (
                      <FunctionField
                        render={(record: any) => (
                          <>
                            <strong>{record.a_name}</strong>
                            <br />
                            <label>{record.a_number}</label>
                          </>
                        )}
                        source="a_number"
                        label="A Number"
                      />
                    ) : (
                      <TextField
                        source="virtual_msisdn_id_data.msisdn"
                        label="A Number"
                      />
                    )}
                    {cdr === "voice" ? (
                      <FunctionField
                        render={(record: any) => (
                          <>
                            <strong>{record.b_name}</strong>
                            <br />
                            <label>{record.b_number}</label>
                          </>
                        )}
                        source="b_number"
                        label="B Number"
                      />
                    ) : (
                      <TextField
                        source="counterparty_msisdn"
                        label="B Number"
                      />
                    )}
                    <TextField source="status" />
                    <TextField source="hkd_cost" label="Cost" />
                    <FunctionField
                      source="data"
                      render={(record: any) => {
                        return (
                          <ReactJson
                            src={record.data || []}
                            shouldCollapse={() => true}
                            enableClipboard={false}
                            displayDataTypes={false}
                            displayObjectSize={false}
                            name={false}
                          />
                        );
                      }}
                    />
                  </Datagrid>
                </ReferenceManyField>
              </Tab>
              <Tab label="Device Log Info" path="device_info">
                <Grid container gap={3}>
                  <TF
                    id="date"
                    label="From"
                    type="date"
                    value={datex}
                    onChange={(e) => {
                      setDate(e.target.value);
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TF
                    id="date"
                    label="To"
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={datey}
                    onChange={(e) => {
                      setDatey(e.target.value);
                    }}
                  />
                </Grid>
                <ReferenceManyField
                  label=""
                  reference="subscribers"
                  target="id"
                  perPage={25}
                  pagination={<Pagination />}
                  filter={{
                    table: "device_logs",
                    type: "minute",
                    start: datex,
                    end: datey,
                  }}
                  sort={{ field: "created_at", order: "desc" }}
                >
                  <Datagrid bulkActionButtons={false}>
                    <DateField source="created_at" showTime />
                    <TextField source="info" />
                    <TextField source="fingerprint" />
                  </Datagrid>
                </ReferenceManyField>
              </Tab>
              <Tab label="KYC" path="kyc">
                <Grid container gap={3}>
                  <TF
                    id="date"
                    label="From"
                    type="date"
                    value={datex}
                    onChange={(e) => {
                      setDate(e.target.value);
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TF
                    id="date"
                    label="To"
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={datey}
                    onChange={(e) => {
                      setDatey(e.target.value);
                    }}
                  />
                </Grid>
                <ReferenceManyField
                  label=""
                  reference="subscribers"
                  target="id"
                  pagination={<Pagination />}
                  perPage={25}
                  filter={{
                    table: "kyc",
                    type: "kyc",
                    start: datex,
                    end: datey,
                  }}
                  sort={{ field: "created_at", order: "desc" }}
                >
                  <Datagrid
                    bulkActionButtons={false}
                    rowStyle={(record: any) => ({
                      backgroundColor:
                        record.status === "REJECTED"
                          ? "#ffa5a5"
                          : record.status === "APPROVED"
                            ? "#c0ffa5"
                            : "",
                    })}
                  >
                    <TextField label="Type" source="type" />
                    <TextField label="Status" source="status" />
                    <TextField
                      label="Verified By"
                      source="verified_by_data.email"
                    />
                    <TextField label="Remark" source="remark" />

                      <DateField source="created_at" showTime />
                      <DateField source="updated_at" showTime />
                      <FunctionField
                        label="Document"
                        render={(record: any) => {
                          return (
                            <div>
                              {record.type === "ACCOUNT" ? (
                                record.passports_registration_id_list?.data[0]?.document_id === '-' && record.passports_registration_id_list?.data[0]?.selfie_id === '-' ? (
                                  <div>
                                  <Button
                                    size="small"
                                    variant="contained"
                                    style={{ marginRight: "5px" }}
                                    onClick={() => {
                                      decryptFile(
                                        record.user_id_data,
                                        record.passports_registration_id_list
                                          ?.data[0].arc_front,
                                        record
                                      );
                                    }}
                                    disabled={
                                      record?.passports_registration_id_list
                                        ?.data[0]?.arc_front === null ||
                                      record?.passports_registration_id_list
                                        ?.data[0]?.arc_front === undefined
                                    }
                                  >
                                    ARC FRONT
                                  </Button>
                                  <Button
                                    size="small"
                                    variant="contained"
                                    onClick={() => {
                                      decryptFile(
                                        record.user_id_data,
                                        record.passports_registration_id_list
                                          ?.data[0].arc_back,
                                        record
                                      );
                                    }}
                                    disabled={
                                      record?.passports_registration_id_list
                                        ?.data[0]?.arc_back === null ||
                                      record?.passports_registration_id_list
                                        ?.data[0]?.arc_back === undefined 
                                    }
                                  >
                                    ARC BACK
                                  </Button>
                                </div>
                                ) : (<div>
                                  <Button
                                    size="small"
                                    variant="contained"
                                    style={{ marginRight: "5px" }}
                                    onClick={() => {
                                      const idColumnName = getDocumentColumn(record);
                                      decryptFile(
                                        record.user_id_data,
                                        record.passports_registration_id_list?.data[0]?.[idColumnName],
                                        record
                                      );
                                    }}
                                    disabled={
                                      !record?.passports_registration_id_list?.data?.[0]?.[
                                        getDocumentColumn(record)
                                      ]
                                    }
                                  >
                                    Document
                                  </Button>
                                  <Button
                                    size="small"
                                    variant="contained"
                                    onClick={() => {
                                      decryptFile(
                                        record.user_id_data,
                                        record.passports_registration_id_list
                                          ?.data[0].selfie_id,
                                        record
                                      );
                                    }}
                                    disabled={
                                      record?.passports_registration_id_list
                                        ?.data[0]?.selfie_id === null ||
                                      record?.passports_registration_id_list
                                        ?.data[0]?.selfie_id === undefined
                                    }
                                  >
                                    Selfie
                                  </Button>
                                </div>)
                                
                              ) : (
                                <div>
                                  <Button
                                    size="small"
                                    variant="contained"
                                    style={{ marginRight: "5px" }}
                                    onClick={() => {
                                      decryptFile(
                                        record.user_id_data,
                                        record
                                          .identity_cards_registration_id_list
                                          ?.data[0].document_id,
                                        record
                                      );
                                    }}
                                    disabled={
                                      record
                                        ?.identity_cards_registration_id_list
                                        ?.data[0]?.document_id === null ||
                                      record
                                        ?.identity_cards_registration_id_list
                                        ?.data[0]?.document_id === undefined
                                    }
                                  >
                                    IDENTITY
                                  </Button>
                                  <Button
                                    size="small"
                                    variant="contained"
                                    onClick={() => {
                                      decryptFile(
                                        record.user_id_data,
                                        record
                                          .identity_cards_registration_id_list
                                          ?.data[0].signature_id,
                                        record
                                      );
                                    }}
                                    disabled={
                                      record
                                        ?.identity_cards_registration_id_list
                                        ?.data[0]?.signature_id === null ||
                                      record
                                        ?.identity_cards_registration_id_list
                                        ?.data[0]?.signature_id === undefined
                                    }
                                  >
                                    SIGNATURE
                                  </Button>
                                </div>
                              )}
                            </div>
                          );
                        }}
                      />
                      <FunctionField
                        label="Action"
                        render={(record: any) => {
                          return record.type === "ACCOUNT" ? (
                            <ReviewKYCPassport data={record} />
                          ) : (
                            <ReviewKYC data={record} />
                          );
                        }}
                      />
                    </Datagrid>
                  </ReferenceManyField>
                </Tab>
                {currentRecord?.is_promotor && (
                  <Tab label="Referred by Promotor" path="referee">
                    <Grid container alignItems="center" spacing={2}>
                      <Stack direction={"row"} justifyContent={"space-between"} width={"100%"} alignItems={"center"}>
                        <Stack direction={"row"} spacing={2} justifyContent={"flex-start"} alignItems={"center"} marginTop={"10px"}>
                          <Grid item paddingLeft={"10px"}>
                            <TF
                              id="date"
                              label="From"
                              type="date"
                              value={datex}
                              onChange={(e) => {
                                setDate(e.target.value);
                              }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </Grid>
                          <Grid item>
                            <TF
                              id="date"
                              label="To"
                              type="date"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              value={datey}
                              onChange={(e) => {
                                setDatey(e.target.value);
                              }}
                            />
                          </Grid>
                          <Grid item>
                            <Autocomplete
                              options={[
                                { id: "M21", label: "M21" },
                                { id: "GHK", label: "GHK" },
                              ]}
                              sx={{ width: 200 }}
                              getOptionLabel={(option) => option.label}
                              onChange={(e, newValue) => {
                                if (!newValue) {
                                  setApp("")
                                  return
                                }
                                setApp(newValue?.id)
                              }}
                              value={{ id: app, label: app }}
                              size="small"
                              renderInput={(params) => (
                                <TF
                                  {...params}
                                  label="App"
                                  variant="outlined"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  size="small"
                                />
                              )}
                            />

                        </Grid>
                      </Stack>
                      <Grid item>
                        <ExportReferredButton subs_id={currentRecord.id} />
                      </Grid>
                    </Stack>
                  </Grid>
                  <ReferenceManyField
                    label=""
                    reference="subscribers"
                    target="id"
                    perPage={25}
                    filter={{
                      table: "referral",
                      start: datex,
                      end: datey,
                      app
                    }}
                    sort={{ field: "added_at", order: "desc" }}
                  >
                    <Datagrid bulkActionButtons={false}>
                      <TextField source="name" label="Name" />
                      <TextField source="app" label="App" sortable={false} />
                      <DateField source="added_at" showTime />
                    </Datagrid>
                  </ReferenceManyField>
                </Tab>
              )}
            </TabbedShowLayout>
          </SimpleShowLayout>
        </Show>
      )}
    </ShowController>
    </>
  );
};

export default ExpandShow;
